import { useOrderSearchForm } from '@euler/app/flows/search/context';
import { FormGroup } from '@euler/components/form';
import { Input } from '@euler/components/form/Input';
import { memo } from 'react';

export const KeywordField = memo(() => {
  const { form } = useOrderSearchForm();
  return (
    <FormGroup label="关键词">
      <Input
        value={form.keyword.value ?? ''}
        placeholder="按关键词搜索"
        clearButtonMode="always"
        onChangeText={form.keyword.update}
      />
    </FormGroup>
  );
});
